import { useEffect, useRef, useState } from "react";

export const useImage = (url: string) => {
    const ref = useRef<HTMLImageElement>();
    const [isLoaded, setLoaded] = useState(false);

    const handleImageLoad = () => {
        setLoaded(true);
    };

    useEffect(() => {
        ref.current = new Image();
        ref.current.src = url;
        ref.current.addEventListener("load", handleImageLoad);

        return () => {
            ref.current?.removeEventListener("load", handleImageLoad);
        };
        // eslint-disable-next-line
    }, []);

    return { ref, isLoaded };
};
